<template>
  <div class="app-container">
    <div class="filter-container">
      <el-select
        v-model="listQuery.school_id"
        placeholder="请选择学校"
        style="width: 150px; margin-right: 10px"
        class="filter-item"
        @change="getInfo()"
      >
        <el-option
          v-for="item in schools"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-date-picker
        v-model="listQuery.class_grade_update_at"
        type="date"
        class="filter-item"
        value-format="yyyy-MM-dd"
        format="MM-dd"
        placeholder="班级自动升级时间"
      >
      </el-date-picker>
      <el-button class="filter-item" type="primary" @click="handleTime">
        保存
      </el-button>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";
export default {
  data() {
    return {
      listQuery: {
        class_grade_update_at: "",
        school_id: "",
      },
      schools: [],
    };
  },
  created() {
    this.getSchoolList();
  },
  methods: {
    //  获取学校列表
    getSchoolList() {
      request({
        url: "/api/backend/school/list",
        method: "get",
        params: { limit: 9999999 },
      }).then((response) => {
        this.schools = response.data.data;
      });
    },
    handleTime() {
      if (!this.listQuery.school_id) {
        this.$message.warning("学校不能为空");
        return;
      }
      if (!this.listQuery.class_grade_update_at) {
        this.$message.warning("自动升级时间不能为空");
        return;
      }
      request({
        url: "/api/backend/school/classGradeUpdateAtStore",
        method: "post",
        data: {
          class_grade_update_at: this.listQuery.class_grade_update_at,
          school_id: this.listQuery.school_id,
        },
      }).then((res) => {
        this.$message({
          type: "success",
          message: "保存成功",
        });
        this.getInfo();
      });
    },
    getInfo() {
      request({
        url: "/api/backend/school/detail",
        method: "get",
        params: {
          id: this.listQuery.school_id,
        },
      }).then((res) => {
        this.listQuery.class_grade_update_at = res.data.class_grade_update_at;
        // this.listQuery.school_id = res.data.school_id;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
</style>